import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=377b1b45"
import script from "./ActivityView.vue?vue&type=script&lang=ts"
export * from "./ActivityView.vue?vue&type=script&lang=ts"
import style0 from "./ActivityView.vue?vue&type=style&index=0&id=377b1b45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports